import {
  Auth,
  createAuth,
} from '@spotify-internal/oauth-silent-authentication';

let authMemo: Auth | undefined;

export const getAuth = () => {
  if (!authMemo) {
    authMemo =
      typeof window !== 'undefined'
        ? createAuth({
            clientId: 'a63ffcb24f064230a10996d4150ce557',
            scopes: ['openid', 'profile', 'email'],
          })
        : undefined;
  }
  return authMemo;
};
